import { API_URL } from '../../../app-config/constants';
import CalendarSettingsDto from '../../../types/CalendarSettingsDto';
import CalendarSettingsUpdateRequest from '../../../types/CalendarSettingsUpdateRequest';
import { get, put } from '../request';

export function getCalendarSettings() {
    return get<CalendarSettingsDto>(`${API_URL}/meeting-calendar-integration/settings`);
}

updateCalendarSettings.operation = 'NO_OPERATION';
export function updateCalendarSettings(CalendarSettingsUpdate: CalendarSettingsUpdateRequest) {
    return put<void>(`${API_URL}/meeting-calendar-integration/settings`, {
        postData: CalendarSettingsUpdate,
    });
}
